import PropTypes from 'prop-types';
import React from 'react';
import TextField from './TextField';
import { MAX_TEXT_LENGTH } from './const/lengths';

const EntityTextField = props => (
  <TextField {...props} maxLength={MAX_TEXT_LENGTH} />
);

EntityTextField.propTypes = {
  required: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
};

EntityTextField.defaultProps = {
  required: true,
  name: 'text',
  label: 'Text',
};

export default EntityTextField;
